<mat-card>
	<mat-card-header>
		<mat-card-title>
			Contact Info
		</mat-card-title>
	</mat-card-header>

	<mat-card-content *ngIf="partyId">
		<div class="row">
			<view-party-contact-mechanism class="col-lg-12" [partyId]="partyId!"
				[enabledTypes]="['postalAddresses', 'phoneNumbers']"
				[filterAddressTypes]="['Current Address','Mailing Address']"
				[filterPhoneNumberTypes]="['Current Address Phone', 'Mailing Address Phone']"
				[removeAddressTypes]="['Birthplace Address']">
			</view-party-contact-mechanism>
		</div>
	</mat-card-content>
</mat-card>